/**
 * Responsável por .
 * @author: fabio.junior
 * Date: 10/12/13
 * Time: 15:11
 */


Greenmile.MarkerLocation = Greenmile.MarkerLocation || {};
Greenmile.MarkerLocation.GeneralFunctions = function () {

    Greenmile.Marker.GeneralFunctions.apply(this, arguments);

    this.renderPopUpTemplate = function (data) {

        var content = '<div class="stopDetail pois"><div class="stopDetailContent">';

        content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelKey + '</span>:';
        content += '</div><div class="windowContent"><a id="linkToLocation" href="#/Location/edit/' + data.id + '">' + data.key + '</a></div></div>';

        if (data.description && data.description !== "") {
            content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelDescription + '</span>:';
            content += '</div><div class="windowContent">' + data.description + '</div></div>';
        }

        if (data.address1 && data.address1 !== "") {
            content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelAddress1 + '</span>:';
            content += '</div><div class="windowContent">' + data.address1 + '</div></div>';
        }

        if (data.address2 && data.address2 !== "") {
            content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelAddress2 + '</span>:';
            content += '</div><div class="windowContent">' + data.address2 + '</div></div>';
        }

        if (data.district && data.district !== "") {
            content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelDistrict + '</span>:';
            content += '</div><div class="windowContent">' + data.district + '</div></div>';
        }

        if (data.zipcode && data.zipcode !== "") {
            content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelZipcode + '</span>:';
            content += '</div><div class="windowContent">' + data.zipcode + '</div></div>';
        }

        if (data.city && data.city !== "") {
            content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelCity + '</span>:';
            content += '</div><div class="windowContent">' + data.city + '</div></div>';
        }

        if (data.state && data.state !== "") {
            content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelState + '</span>:';
            content += '</div><div class="windowContent">' + data.state + '</div></div>';
        }

        if (data.country && data.country !== "") {
            content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelCountry + '</span>:';
            content += '</div><div class="windowContent">' + data.country + '</div></div>';
        }

        if (data.phone && data.phone.trim() !== "") {
            content += '<div class="stopDetailWindow"><div class="windowLabel"><span class="i18nResource">' + data.labelPhone + '</span>:';
            content += '</div><div class="windowContent">' + data.phone + '</div></div>';
        }

        content += '</div></div>';

        return content;

    };

    this.renderContentToPopup = function (location, marker, noCloseButton) {

        var divParent = document.createElement('div');
        var divContent = document.createElement('div');
        var divCloseButton = document.createElement('div');
        var i18n = Monet.I18n;

        var eventToClosePopup = function (context, marker) {

            return function () {
                marker.closePopup();
            };

        }(this, marker);

        divContent.innerHTML = this.renderPopUpTemplate({
            id: location.id,
            labelKey: i18n.getResourcesByKey('location.key'),
            key: location.key,
            labelDescription: i18n.getResourcesByKey('location.description'),
            description: location.description,
            labelAddress1: i18n.getResourcesByKey('location.address'),
            address1: location.addressLine1,
            labelAddress2: i18n.getResourcesByKey('location.address') + " 2",
            address2: location.addressLine2,
            labelDistrict: i18n.getResourcesByKey('location.district'),
            district: location.district,
            labelZipcode: i18n.getResourcesByKey('location.zip'),
            zipcode: location.zipcode,
            labelCity: i18n.getResourcesByKey('location.city'),
            city: location.city,
            labelState: i18n.getResourcesByKey('location.state'),
            state: location.state,
            labelCountry: i18n.getResourcesByKey('location.country'),
            country: location.country,
            labelPhone: i18n.getResourcesByKey('location.phone1'),
            phone: location.phone1
        });

        divCloseButton.className = 'mapsBtnClosePopup';

        divCloseButton.innerHTML = 'x';
        divCloseButton.removeEventListener('click', eventToClosePopup);
        divCloseButton.addEventListener('click', eventToClosePopup);
        if (!noCloseButton) {
            divParent.appendChild(divCloseButton);
        }

        divParent.appendChild(divContent);

        var link = divParent.querySelector('#linkToLocation');
        var routerLocation = null;

        if (link !== null) {
            link.addEventListener('click', function () {

                if (location !== null) {
                    window.location = "#/Location/edit/" + location.id;
                    routerLocation = new App.Routers.Location();
                    routerLocation.edit(location.id);
                    routerLocation.destroyMapOverlay();
                    return false;
                }

            });
        }

        return divParent;

    };

    this.createMarker = function (location) {

        this.setModel(location);

        var params = {
            position: [
                location.latitude,
                location.longitude
            ],
            kind: Greenmile.Marker.Kind.LOCATION,
            offset: [42, -38],
            minWidth: 430
        };

        return this.createGenericMarker(location.id, params);

    };

};
